var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 156.664,
    height: 468.683,
    viewBox: "0 0 156.664 468.683",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16770",
    "data-name": "Group 16770",
    transform: "translate(-1027.135 -486.191)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16474",
    "data-name": "Group 16474",
    transform: "translate(1041.812 695.536)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16470",
    "data-name": "Group 16470"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16469",
    "data-name": "Group 16469"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16468",
    "data-name": "Group 16468"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16356",
    "data-name": "Group 16356",
    transform: "translate(16.546 200.069)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16355",
    "data-name": "Group 16355"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16354",
    "data-name": "Group 16354"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16276",
    "data-name": "Group 16276"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16275",
    "data-name": "Group 16275"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16274",
    "data-name": "Group 16274"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16273",
    "data-name": "Group 16273"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16272",
    "data-name": "Group 16272"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16271",
    "data-name": "Group 16271"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16270",
    "data-name": "Group 16270"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16269",
    "data-name": "Group 16269"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16268",
    "data-name": "Group 16268"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16267",
    "data-name": "Group 16267"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16266",
    "data-name": "Group 16266"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16265",
    "data-name": "Group 16265"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63208",
    "data-name": "Path 63208",
    d: "M1090.152,824.022l-8,28.075s25.478,17.667,24.5,23l-54.283-13.759,10.692-44.263Z",
    transform: "translate(-1052.369 -817.076)",
    fill: "#455a64"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16289",
    "data-name": "Group 16289",
    transform: "translate(11.421 28.36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16288",
    "data-name": "Group 16288"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16287",
    "data-name": "Group 16287"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16286",
    "data-name": "Group 16286"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16285",
    "data-name": "Group 16285"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16284",
    "data-name": "Group 16284"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16283",
    "data-name": "Group 16283"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16282",
    "data-name": "Group 16282"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16281",
    "data-name": "Group 16281"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16280",
    "data-name": "Group 16280"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16279",
    "data-name": "Group 16279"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16278",
    "data-name": "Group 16278"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16277",
    "data-name": "Group 16277"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63209",
    "data-name": "Path 63209",
    d: "M1063.766,840.019a2.3,2.3,0,0,0-2.167,2.175,2.213,2.213,0,0,0,2.108,2.194,2.426,2.426,0,0,0,2.282-2.315c-.1-1.132-1.354-2.314-2.443-2.035",
    transform: "translate(-1061.6 -839.997)",
    fill: "#e0e0e0"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16301",
    "data-name": "Group 16301",
    transform: "translate(0 39.844)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16300",
    "data-name": "Group 16300"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16299",
    "data-name": "Group 16299"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16298",
    "data-name": "Group 16298"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16297",
    "data-name": "Group 16297"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16296",
    "data-name": "Group 16296"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16295",
    "data-name": "Group 16295"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16294",
    "data-name": "Group 16294"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16293",
    "data-name": "Group 16293"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16292",
    "data-name": "Group 16292"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16291",
    "data-name": "Group 16291"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16290",
    "data-name": "Group 16290"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63210",
    "data-name": "Path 63210",
    d: "M1052.369,853.7l1.251-4.418,51.577,14.844s2.154,1.678,1.455,3.333Z",
    transform: "translate(-1052.369 -849.278)",
    fill: "#fff"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16314",
    "data-name": "Group 16314",
    transform: "translate(25.038 34.384)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16313",
    "data-name": "Group 16313"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16312",
    "data-name": "Group 16312"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16311",
    "data-name": "Group 16311"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16310",
    "data-name": "Group 16310"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16309",
    "data-name": "Group 16309"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16308",
    "data-name": "Group 16308"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16307",
    "data-name": "Group 16307"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16306",
    "data-name": "Group 16306"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16305",
    "data-name": "Group 16305"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16304",
    "data-name": "Group 16304"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16303",
    "data-name": "Group 16303"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16302",
    "data-name": "Group 16302"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63211",
    "data-name": "Path 63211",
    d: "M1078.3,845.445c-.074.266-1.43.052-2.947.585-1.532.492-2.491,1.486-2.708,1.318-.231-.115.56-1.62,2.409-2.232C1076.895,844.486,1078.418,845.213,1078.3,845.445Z",
    transform: "translate(-1072.604 -844.865)",
    fill: "#263238"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16327",
    "data-name": "Group 16327",
    transform: "translate(31.298 38.56)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16326",
    "data-name": "Group 16326"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16325",
    "data-name": "Group 16325"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16324",
    "data-name": "Group 16324"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16323",
    "data-name": "Group 16323"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16322",
    "data-name": "Group 16322"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16321",
    "data-name": "Group 16321"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16320",
    "data-name": "Group 16320"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16319",
    "data-name": "Group 16319"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16318",
    "data-name": "Group 16318"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16317",
    "data-name": "Group 16317"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16316",
    "data-name": "Group 16316"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16315",
    "data-name": "Group 16315"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63212",
    "data-name": "Path 63212",
    d: "M1082.2,848.474c0,.275-1.265.441-2.445,1.349-1.208.872-1.738,2.043-2,1.965-.259-.021-.054-1.641,1.435-2.741S1082.261,848.215,1082.2,848.474Z",
    transform: "translate(-1077.664 -848.24)",
    fill: "#263238"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16340",
    "data-name": "Group 16340",
    transform: "translate(37.215 42.377)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16339",
    "data-name": "Group 16339"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16338",
    "data-name": "Group 16338"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16337",
    "data-name": "Group 16337"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16336",
    "data-name": "Group 16336"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16335",
    "data-name": "Group 16335"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16334",
    "data-name": "Group 16334"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16333",
    "data-name": "Group 16333"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16332",
    "data-name": "Group 16332"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16331",
    "data-name": "Group 16331"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16330",
    "data-name": "Group 16330"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16329",
    "data-name": "Group 16329"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16328",
    "data-name": "Group 16328"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63213",
    "data-name": "Path 63213",
    d: "M1082.6,855.465c-.255,0-.292-1.439.752-2.737s2.427-1.57,2.484-1.318c.1.259-.9.844-1.746,1.923C1083.223,854.392,1082.867,855.506,1082.6,855.465Z",
    transform: "translate(-1082.446 -851.324)",
    fill: "#263238"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16353",
    "data-name": "Group 16353",
    transform: "translate(26.139 26.579)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16352",
    "data-name": "Group 16352"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16351",
    "data-name": "Group 16351"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16350",
    "data-name": "Group 16350"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16349",
    "data-name": "Group 16349"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16348",
    "data-name": "Group 16348"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16347",
    "data-name": "Group 16347"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16346",
    "data-name": "Group 16346"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16345",
    "data-name": "Group 16345"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16344",
    "data-name": "Group 16344"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16343",
    "data-name": "Group 16343"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16342",
    "data-name": "Group 16342"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16341",
    "data-name": "Group 16341"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63214",
    "data-name": "Path 63214",
    d: "M1079.21,840.339c-.171.216-1.3-.462-2.82-.739-1.517-.308-2.809-.094-2.89-.359-.105-.234,1.278-.939,3.069-.588S1079.393,840.16,1079.21,840.339Z",
    transform: "translate(-1073.494 -838.557)",
    fill: "#263238"
  }))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16448",
    "data-name": "Group 16448",
    transform: "translate(7.237 213.328)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16447",
    "data-name": "Group 16447"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16446",
    "data-name": "Group 16446"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16368",
    "data-name": "Group 16368"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16367",
    "data-name": "Group 16367"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16366",
    "data-name": "Group 16366"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16365",
    "data-name": "Group 16365"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16364",
    "data-name": "Group 16364"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16363",
    "data-name": "Group 16363"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16362",
    "data-name": "Group 16362"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16361",
    "data-name": "Group 16361"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16360",
    "data-name": "Group 16360"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16359",
    "data-name": "Group 16359"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16358",
    "data-name": "Group 16358"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16357",
    "data-name": "Group 16357"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63215",
    "data-name": "Path 63215",
    d: "M1072.909,828.089l-1.26,29.194s28.863,11.1,29.149,16.52l-55.953-.441.12-45.569Z",
    transform: "translate(-1044.845 -827.792)",
    fill: "#455a64"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16381",
    "data-name": "Group 16381",
    transform: "translate(7.875 26.806)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16380",
    "data-name": "Group 16380"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16379",
    "data-name": "Group 16379"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16378",
    "data-name": "Group 16378"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16377",
    "data-name": "Group 16377"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16376",
    "data-name": "Group 16376"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16375",
    "data-name": "Group 16375"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16374",
    "data-name": "Group 16374"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16373",
    "data-name": "Group 16373"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16372",
    "data-name": "Group 16372"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16371",
    "data-name": "Group 16371"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16370",
    "data-name": "Group 16370"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16369",
    "data-name": "Group 16369"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63216",
    "data-name": "Path 63216",
    d: "M1052.856,849.547a2.319,2.319,0,0,0-1.6,2.631,2.2,2.2,0,0,0,2.559,1.63,2.443,2.443,0,0,0,1.68-2.794,2.271,2.271,0,0,0-2.847-1.4",
    transform: "translate(-1051.209 -849.456)",
    fill: "#e0e0e0"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16393",
    "data-name": "Group 16393",
    transform: "translate(0 40.977)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16392",
    "data-name": "Group 16392"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16391",
    "data-name": "Group 16391"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16390",
    "data-name": "Group 16390"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16389",
    "data-name": "Group 16389"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16388",
    "data-name": "Group 16388"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16387",
    "data-name": "Group 16387"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16386",
    "data-name": "Group 16386"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16385",
    "data-name": "Group 16385"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16384",
    "data-name": "Group 16384"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16383",
    "data-name": "Group 16383"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16382",
    "data-name": "Group 16382"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63217",
    "data-name": "Path 63217",
    d: "M1044.845,865.5l.189-4.593,53.576,2.141s2.482,1.117,2.188,2.893Z",
    transform: "translate(-1044.845 -860.909)",
    fill: "#fff"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16406",
    "data-name": "Group 16406",
    transform: "translate(22.59 28.946)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16405",
    "data-name": "Group 16405"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16404",
    "data-name": "Group 16404"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16403",
    "data-name": "Group 16403"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16402",
    "data-name": "Group 16402"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16401",
    "data-name": "Group 16401"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16400",
    "data-name": "Group 16400"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16399",
    "data-name": "Group 16399"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16398",
    "data-name": "Group 16398"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16397",
    "data-name": "Group 16397"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16396",
    "data-name": "Group 16396"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16395",
    "data-name": "Group 16395"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16394",
    "data-name": "Group 16394"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63218",
    "data-name": "Path 63218",
    d: "M1068.224,851.449c-.011.277-1.377.391-2.728,1.271-1.375.844-2.076,2.038-2.327,1.926-.251-.056.168-1.707,1.824-2.744S1068.286,851.2,1068.224,851.449Z",
    transform: "translate(-1063.102 -851.186)",
    fill: "#263238"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16419",
    "data-name": "Group 16419",
    transform: "translate(29.825 31.601)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16418",
    "data-name": "Group 16418"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16417",
    "data-name": "Group 16417"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16416",
    "data-name": "Group 16416"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16415",
    "data-name": "Group 16415"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16414",
    "data-name": "Group 16414"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16413",
    "data-name": "Group 16413"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16412",
    "data-name": "Group 16412"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16411",
    "data-name": "Group 16411"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16410",
    "data-name": "Group 16410"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16409",
    "data-name": "Group 16409"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16408",
    "data-name": "Group 16408"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16407",
    "data-name": "Group 16407"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63219",
    "data-name": "Path 63219",
    d: "M1072.687,853.446c.061.268-1.126.73-2.063,1.894-.971,1.135-1.215,2.4-1.487,2.384-.257.042-.433-1.581.759-3.005S1072.683,853.182,1072.687,853.446Z",
    transform: "translate(-1068.949 -853.331)",
    fill: "#263238"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16432",
    "data-name": "Group 16432",
    transform: "translate(36.521 34.098)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16431",
    "data-name": "Group 16431"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16430",
    "data-name": "Group 16430"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16429",
    "data-name": "Group 16429"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16428",
    "data-name": "Group 16428"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16427",
    "data-name": "Group 16427"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16426",
    "data-name": "Group 16426"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16425",
    "data-name": "Group 16425"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16424",
    "data-name": "Group 16424"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16423",
    "data-name": "Group 16423"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16422",
    "data-name": "Group 16422"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16421",
    "data-name": "Group 16421"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16420",
    "data-name": "Group 16420"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63220",
    "data-name": "Path 63220",
    d: "M1074.681,860.11c-.249.057-.619-1.329.1-2.84s1.995-2.1,2.11-1.872c.152.229-.684,1.036-1.251,2.285C1075.04,858.918,1074.952,860.085,1074.681,860.11Z",
    transform: "translate(-1074.361 -855.35)",
    fill: "#263238"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16445",
    "data-name": "Group 16445",
    transform: "translate(21.453 21.508)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16444",
    "data-name": "Group 16444"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16443",
    "data-name": "Group 16443"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16442",
    "data-name": "Group 16442"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16441",
    "data-name": "Group 16441"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16440",
    "data-name": "Group 16440"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16439",
    "data-name": "Group 16439"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16438",
    "data-name": "Group 16438"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16437",
    "data-name": "Group 16437"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16436",
    "data-name": "Group 16436"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16435",
    "data-name": "Group 16435"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16434",
    "data-name": "Group 16434"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16433",
    "data-name": "Group 16433"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63221",
    "data-name": "Path 63221",
    d: "M1068,846.191c-.116.251-1.367-.141-2.913-.047-1.547.063-2.753.579-2.893.34-.157-.2,1.024-1.217,2.846-1.3S1068.138,845.974,1068,846.191Z",
    transform: "translate(-1062.183 -845.175)",
    fill: "#263238"
  }))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16467",
    "data-name": "Group 16467"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16457",
    "data-name": "Group 16457"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16456",
    "data-name": "Group 16456"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16455",
    "data-name": "Group 16455"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16454",
    "data-name": "Group 16454"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16453",
    "data-name": "Group 16453"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16452",
    "data-name": "Group 16452"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16451",
    "data-name": "Group 16451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16450",
    "data-name": "Group 16450"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16449",
    "data-name": "Group 16449"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63222",
    "data-name": "Path 63222",
    d: "M1039.681,655.382v23.082l6.118,89.93s-3.807,43.626-6.146,68.251c-2.031,21.387,1.289,58.631,1.289,58.631h35.614l12.742-124.21,7.909-77.464,13.76-35.256Z",
    transform: "translate(-1038.996 -655.382)",
    fill: "#1b3d9e"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16466",
    "data-name": "Group 16466",
    transform: "translate(28.688)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16465",
    "data-name": "Group 16465"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16464",
    "data-name": "Group 16464"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16463",
    "data-name": "Group 16463"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16462",
    "data-name": "Group 16462"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16461",
    "data-name": "Group 16461"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16460",
    "data-name": "Group 16460"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16459",
    "data-name": "Group 16459"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16458",
    "data-name": "Group 16458"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63223",
    "data-name": "Path 63223",
    d: "M1121.662,655.382l3.441,93.733c-.239,17.587-5.087,50.424-11.375,66.818l-28.612,62.872-1.656,5.657-21.278-5.213,15.825-222.292Z",
    transform: "translate(-1062.182 -655.382)",
    fill: "#1b3d9e"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16473",
    "data-name": "Group 16473",
    transform: "translate(37.556 24.827)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16472",
    "data-name": "Group 16472"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16471",
    "data-name": "Group 16471"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63224",
    "data-name": "Path 63224",
    d: "M1095.317,675.447a3.336,3.336,0,0,1,.038.56c.009.4.021.948.037,1.646.012,1.484.03,3.609.052,6.33.016,5.5-.009,13.453-.176,23.282s-.469,21.532-1.169,34.514c-.771,12.958-1.637,27.3-4.678,42.02-2.811,14.74-5.8,28.716-8.456,41.437s-4.987,24.188-6.741,33.856-3,17.521-3.723,22.966c-.408,2.717-.621,4.841-.825,6.273-.094.692-.168,1.232-.223,1.631a3.21,3.21,0,0,1-.1.553,3.374,3.374,0,0,1,.03-.56c.037-.4.089-.944.155-1.64.16-1.438.33-3.567.7-6.292.643-5.46,1.815-13.333,3.51-23.018s3.963-21.171,6.6-33.9,5.592-26.706,8.4-41.437c3.035-14.685,3.916-28.971,4.722-41.927.734-12.967,1.075-24.665,1.317-34.488s.328-17.777.393-23.273c.033-2.72.058-4.845.077-6.329.012-.7.023-1.244.031-1.646A3.52,3.52,0,0,1,1095.317,675.447Z",
    transform: "translate(-1069.349 -675.447)",
    fill: "#455a64"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16549",
    "data-name": "Group 16549",
    transform: "translate(1027.135 561.13)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16476",
    "data-name": "Group 16476",
    transform: "translate(97.946 100.208)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16475",
    "data-name": "Group 16475"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63225",
    "data-name": "Path 63225",
    d: "M1132.08,632.215a15.957,15.957,0,0,1,.526,5.392c-.264,2.762-.395,9.561-7.759,11.881s-14.3-3.2-16.555-5.7-1.987-10.652-1.987-10.652l12.1-5.392Z",
    transform: "translate(-1106.294 -627.743)",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16478",
    "data-name": "Group 16478",
    transform: "translate(9.163)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16477",
    "data-name": "Group 16477"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63226",
    "data-name": "Path 63226",
    d: "M1065.482,547.558l-6.129,9.844-24.813,10.564,6.209,101.867,4.463,18.455,82.629-2.747,3.627-6.158-6.147-78.352c-1.868-17.632-5.819-27.059-13.717-31.395l-5.167-3.531-1.949-6.474-7.286-6.814-23.332-6.06Z",
    transform: "translate(-1034.54 -546.756)",
    fill: "#50aa32"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16481",
    "data-name": "Group 16481",
    transform: "translate(12.627 97.725)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16480",
    "data-name": "Group 16480"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16479",
    "data-name": "Group 16479"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63227",
    "data-name": "Path 63227",
    d: "M1037.34,643.336a25.345,25.345,0,0,0,24.969,11.106c8.3-1.4,15.3-6.872,23.254-9.611,13.843-4.766,29.631-.976,43.277-6.283.268-2.351.109-5.237.268-6.84-6.831-.351-14.1-.733-20.131-3.956l-5.473-2.014Z",
    transform: "translate(-1037.34 -625.737)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16487",
    "data-name": "Group 16487",
    transform: "translate(0 21.21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16483",
    "data-name": "Group 16483",
    transform: "translate(0.175)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16482",
    "data-name": "Group 16482"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63228",
    "data-name": "Path 63228",
    d: "M1036.264,563.9s-11.777,10.088-8.368,36.36c3.168,24.411,8.789,58.418,16.286,62.364s23.67,1.972,35.506-4.734,46.158-24.855,46.158-24.855l-14.2-25.249-45.765,17.753s-5.918-40.494-9.468-47.469",
    transform: "translate(-1027.276 -563.898)",
    fill: "#50aa32"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16486",
    "data-name": "Group 16486"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16485",
    "data-name": "Group 16485"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16484",
    "data-name": "Group 16484"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63229",
    "data-name": "Path 63229",
    d: "M1056.445,578.068s.131.256.356.773c.109.26.257.579.41.969l.448,1.382c.672,2.1,1.475,5.248,2.347,9.339,1.764,8.181,3.895,20.119,6.151,34.969l-.333-.193,45.739-17.819.255-.1.135.24c4.5,7.983,9.272,16.458,14.221,25.239l.168.3-.3.163-29.344,15.809-14.393,7.748c-2.362,1.262-4.716,2.591-7.163,3.644a60.332,60.332,0,0,1-7.48,2.591,49.008,49.008,0,0,1-15.264,1.767,22.365,22.365,0,0,1-7.341-1.539l-.858-.384a6.157,6.157,0,0,1-2.155-1.858,18.146,18.146,0,0,1-1.937-3.114,70.321,70.321,0,0,1-4.589-13.246c-1.149-4.392-2.063-8.7-2.884-12.881-1.62-8.358-2.822-16.2-3.826-23.361s-1.888-13.689-1.621-19.461a48.427,48.427,0,0,1,2.6-14.5,32.005,32.005,0,0,1,4.338-8.239,17.759,17.759,0,0,1,1.568-1.852,5.938,5.938,0,0,1,.611-.557s-.194.2-.561.605a20.847,20.847,0,0,0-1.507,1.887,32.85,32.85,0,0,0-4.2,8.247,48.641,48.641,0,0,0-2.465,14.421c-.23,5.735.679,12.224,1.716,19.379s2.264,14.983,3.905,23.321c.833,4.166,1.753,8.465,2.909,12.836a70.045,70.045,0,0,0,4.569,13.112,17.654,17.654,0,0,0,1.87,3,8.092,8.092,0,0,0,1.225,1.236,7.614,7.614,0,0,0,.728.449l.818.364a21.752,21.752,0,0,0,7.126,1.479,48.437,48.437,0,0,0,15.048-1.762,59.975,59.975,0,0,0,7.387-2.565c2.418-1.043,4.717-2.344,7.095-3.615l14.4-7.754,29.362-15.8-.136.462L1111.4,607.938l.39.14L1066,625.766l-.287.111-.044-.3c-2.191-14.85-4.249-26.8-5.929-34.985-.832-4.1-1.59-7.251-2.218-9.354q-.234-.783-.413-1.388c-.147-.382-.272-.706-.375-.975C1056.533,578.345,1056.445,578.068,1056.445,578.068Z",
    transform: "translate(-1027.135 -563.898)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16493",
    "data-name": "Group 16493",
    transform: "translate(33.25 48.06)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16489",
    "data-name": "Group 16489",
    transform: "translate(0.005 0.334)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16488",
    "data-name": "Group 16488"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63230",
    "data-name": "Path 63230",
    d: "M1054.011,587.822l29.721-1.954,6.575,12.362-33.317,5.99Z",
    transform: "translate(-1054.011 -585.868)",
    fill: "#50aa32"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16492",
    "data-name": "Group 16492"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16491",
    "data-name": "Group 16491"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16490",
    "data-name": "Group 16490"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63231",
    "data-name": "Path 63231",
    d: "M1054.012,587.887a12.081,12.081,0,0,1,.271,1.187q.249,1.234.663,3.291c.561,2.888,1.344,6.93,2.3,11.872l-.3-.21,29.987-5.475,3.315-.6-.241.5c-2.306-4.354-4.511-8.515-6.555-12.373l.3.169-21.294,1.24-6.176.319-1.668.073a4.517,4.517,0,0,1-.6,0,2.537,2.537,0,0,1,.521-.07l1.594-.142,6.088-.486,21.5-1.575.205-.015.1.184c2.057,3.852,4.275,8,6.6,12.35l.221.416-.464.083-3.314.6-30.016,5.313-.261.046-.043-.256c-.854-5.033-1.553-9.15-2.052-12.091q-.328-2.036-.524-3.253A8.734,8.734,0,0,1,1054.012,587.887Z",
    transform: "translate(-1054.008 -585.598)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16496",
    "data-name": "Group 16496",
    transform: "translate(30.665 82.846)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16495",
    "data-name": "Group 16495"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16494",
    "data-name": "Group 16494"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63232",
    "data-name": "Path 63232",
    d: "M1060.031,613.715c.183.142-2.477,3.269-4.7,7.74s-3.166,8.466-3.391,8.4a8.966,8.966,0,0,1,.49-2.641,33.33,33.33,0,0,1,2.287-6.067,31.568,31.568,0,0,1,3.476-5.475A8.793,8.793,0,0,1,1060.031,613.715Z",
    transform: "translate(-1051.918 -613.712)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16499",
    "data-name": "Group 16499",
    transform: "translate(34.027 11.254)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16498",
    "data-name": "Group 16498"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16497",
    "data-name": "Group 16497"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63233",
    "data-name": "Path 63233",
    d: "M1089.24,570.819a10.8,10.8,0,0,1-1.651-1.183l-4.31-3.424.377-.059a40.146,40.146,0,0,1-5.9,7.4l-.213.21-.235-.2c-1.435-1.193-2.968-2.467-4.553-3.783-4.886-3.992-9.443-7.44-12.768-9.9-1.583-1.167-2.905-2.142-3.943-2.909a9.188,9.188,0,0,1-1.408-1.125,8.988,8.988,0,0,1,1.559.9c.975.627,2.376,1.55,4.074,2.734,3.4,2.363,8.021,5.76,12.92,9.763,1.6,1.305,3.134,2.593,4.55,3.81l-.447.016a42.987,42.987,0,0,0,5.935-7.2l.161-.246.215.187,4.166,3.6A10.845,10.845,0,0,1,1089.24,570.819Z",
    transform: "translate(-1054.635 -555.851)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16502",
    "data-name": "Group 16502",
    transform: "translate(69.688 18.287)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16501",
    "data-name": "Group 16501"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16500",
    "data-name": "Group 16500"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63234",
    "data-name": "Path 63234",
    d: "M1094.624,563.216a5.014,5.014,0,0,1,.241,1.658,24.855,24.855,0,0,1-.15,4.4l-.094.781-.452-.656a52.151,52.151,0,0,0-3.53-4.573c-.531-.615-1.065-1.2-1.592-1.757-.255-.264-.546-.582-.766-.776-.266-.165-.236-.173-.461.078l-2.191,3.056a17.445,17.445,0,0,1-2.167,2.725,17.532,17.532,0,0,1,1.767-3c.635-.964,1.33-2.019,2.079-3.154a1,1,0,0,1,.612-.453.966.966,0,0,1,.766.231c.343.292.559.539.846.825.542.557,1.088,1.151,1.627,1.774a40.781,40.781,0,0,1,3.509,4.692l-.546.124C1094.657,565.651,1094.472,563.223,1094.624,563.216Z",
    transform: "translate(-1083.456 -561.536)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16505",
    "data-name": "Group 16505",
    transform: "translate(12.159 21.475)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16504",
    "data-name": "Group 16504"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16503",
    "data-name": "Group 16503"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63235",
    "data-name": "Path 63235",
    d: "M1052.753,574.019a15.242,15.242,0,0,1-1.845-2.19,24.071,24.071,0,0,0-4.873-4.717,15.974,15.974,0,0,0-6.254-2.445,21.653,21.653,0,0,1-2.82-.429,8.281,8.281,0,0,1,2.887-.052,14.4,14.4,0,0,1,6.573,2.357,20.064,20.064,0,0,1,4.874,4.993A9.89,9.89,0,0,1,1052.753,574.019Z",
    transform: "translate(-1036.962 -564.112)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16508",
    "data-name": "Group 16508",
    transform: "translate(88.457 36.748)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16507",
    "data-name": "Group 16507"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16506",
    "data-name": "Group 16506"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63236",
    "data-name": "Path 63236",
    d: "M1102.7,589.332c-.181.057-1.232-2.779-2.35-6.334s-1.877-6.485-1.7-6.542,1.232,2.779,2.35,6.335S1102.879,589.275,1102.7,589.332Z",
    transform: "translate(-1098.625 -576.455)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16510",
    "data-name": "Group 16510",
    transform: "translate(49.897 58.552)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16509",
    "data-name": "Group 16509"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63237",
    "data-name": "Path 63237",
    d: "M1067.852,594.542a1.6,1.6,0,1,0,.393-.3",
    transform: "translate(-1067.461 -594.077)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16512",
    "data-name": "Group 16512",
    transform: "translate(31.274 41.445)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16511",
    "data-name": "Group 16511"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63238",
    "data-name": "Path 63238",
    d: "M1052.41,580.251l8.336,24.695L1088.229,600l-26.5,10.384-2.223,8.561Z",
    transform: "translate(-1052.41 -580.251)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16514",
    "data-name": "Group 16514",
    transform: "translate(34.733 11.739)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16513",
    "data-name": "Group 16513"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63239",
    "data-name": "Path 63239",
    d: "M1055.206,556.243l24.576,22.274,3.8-10.391,3.983,1.325-4.259-3.528s-4.667,7.174-5.918,7.3Z",
    transform: "translate(-1055.206 -556.243)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16517",
    "data-name": "Group 16517",
    transform: "translate(68.993 27.035)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16516",
    "data-name": "Group 16516"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16515",
    "data-name": "Group 16515"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63240",
    "data-name": "Path 63240",
    d: "M1095.459,606.564a6.882,6.882,0,0,1-.5-1.5c-.314-1.114-.7-2.493-1.162-4.128-.98-3.483-2.388-8.279-4.119-13.518s-3.466-9.929-4.757-13.311c-.6-1.585-1.116-2.924-1.528-4.005a6.837,6.837,0,0,1-.49-1.5,6.992,6.992,0,0,1,.736,1.4c.436.917,1.03,2.258,1.734,3.93,1.409,3.341,3.217,8.018,4.958,13.274s3.075,10.088,3.936,13.611c.432,1.761.756,3.192.952,4.187A7.056,7.056,0,0,1,1095.459,606.564Z",
    transform: "translate(-1082.894 -568.606)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16548",
    "data-name": "Group 16548",
    transform: "translate(66.991 34.013)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16519",
    "data-name": "Group 16519",
    transform: "translate(13.595)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16518",
    "data-name": "Group 16518"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63241",
    "data-name": "Path 63241",
    d: "M1092.873,577.787c4.649,4.639,16.421,16.719,16.421,16.719l3.151-1.9L1095.854,574.9a2.076,2.076,0,0,0-2.661-.311h0A2.075,2.075,0,0,0,1092.873,577.787Z",
    transform: "translate(-1092.264 -574.245)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16531",
    "data-name": "Group 16531",
    transform: "translate(17.552 15.667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16521",
    "data-name": "Group 16521"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16520",
    "data-name": "Group 16520"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63242",
    "data-name": "Path 63242",
    d: "M1095.462,602.323l3.954-11.137a6.256,6.256,0,0,1,5.7-4.279,5.11,5.11,0,0,1,.6.03c2.367.262,14.466,1.052,14.466,1.052l4.682,5.246a2.424,2.424,0,0,1,.052,3.17h0l1.344,9.469-2.659,1.8.263,6.618s-2.367,1.578-3.42,1.052l-1.052-.526-1.578-1.579-4.472,6.313-6.183,3.576Z",
    transform: "translate(-1095.462 -586.907)",
    fill: "#ffbf9d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16524",
    "data-name": "Group 16524",
    transform: "translate(13.612 5.13)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16523",
    "data-name": "Group 16523"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16522",
    "data-name": "Group 16522"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63243",
    "data-name": "Path 63243",
    d: "M1122.323,595.926a19.709,19.709,0,0,0-1.694-1.842,7.86,7.86,0,0,0-2.259-1.362,17.5,17.5,0,0,0-3.272-.443c-4.787-.449-8.654-.968-8.635-1.156s3.912.022,8.7.471a15.18,15.18,0,0,1,3.419.531,7.43,7.43,0,0,1,2.377,1.6A3.968,3.968,0,0,1,1122.323,595.926Z",
    transform: "translate(-1106.463 -591.053)",
    fill: "#ff9a6c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16527",
    "data-name": "Group 16527",
    transform: "translate(14.71 10.812)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16526",
    "data-name": "Group 16526"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16525",
    "data-name": "Group 16525"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63244",
    "data-name": "Path 63244",
    d: "M1121.852,603.545a18.659,18.659,0,0,0-.973-2.423,9.462,9.462,0,0,0-4.677-3.92,17.793,17.793,0,0,0-6.188-1.039,14.115,14.115,0,0,1-2.664-.087,8.25,8.25,0,0,1,2.655-.4,15.368,15.368,0,0,1,6.449.886,9.123,9.123,0,0,1,4.854,4.332A4.183,4.183,0,0,1,1121.852,603.545Z",
    transform: "translate(-1107.351 -595.645)",
    fill: "#ff9a6c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16530",
    "data-name": "Group 16530",
    transform: "translate(15.399 18.077)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16529",
    "data-name": "Group 16529"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16528",
    "data-name": "Group 16528"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63245",
    "data-name": "Path 63245",
    d: "M1120.53,610.275a5.134,5.134,0,0,1-.632-2.611,8.656,8.656,0,0,0-.594-2.711,3.353,3.353,0,0,0-2.484-1.887,46.7,46.7,0,0,0-6.3-.908,7.111,7.111,0,0,1-2.615-.609,19.469,19.469,0,0,1,2.658.125,30.967,30.967,0,0,1,6.435.729,5,5,0,0,1,1.773.813,3.574,3.574,0,0,1,1.109,1.482,8.138,8.138,0,0,1,.5,2.932C1120.383,609.277,1120.608,610.239,1120.53,610.275Z",
    transform: "translate(-1107.907 -601.517)",
    fill: "#ff9a6c"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16533",
    "data-name": "Group 16533",
    transform: "translate(0 21.592)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16532",
    "data-name": "Group 16532"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63246",
    "data-name": "Path 63246",
    d: "M1133.442,591.7l-52.166,53.878,2.008,2.035,37.374-4.208,50.292-47.908-.055-2.306Z",
    transform: "translate(-1081.277 -591.695)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16536",
    "data-name": "Group 16536",
    transform: "translate(36.707 52.899)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16535",
    "data-name": "Group 16535"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16534",
    "data-name": "Group 16534"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63247",
    "data-name": "Path 63247",
    d: "M1129.779,619.552a9.784,9.784,0,0,0-7.532-2.52,13.818,13.818,0,0,0-7.431,3.135,9.995,9.995,0,0,0-3.7,5.293c-.871,3.728,1.606,7.641,4.983,9.445l.47-.539,12.85-10.319a3.608,3.608,0,0,0,1.487-1.9A3.005,3.005,0,0,0,1129.779,619.552Z",
    transform: "translate(-1110.943 -616.998)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16538",
    "data-name": "Group 16538",
    transform: "translate(37.012 50.415)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16537",
    "data-name": "Group 16537"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63248",
    "data-name": "Path 63248",
    d: "M1124.211,614.99s5.062.1,6.708.919,6.181,5.656,6.181,5.656,0,3.288-1.315,3.419a12.364,12.364,0,0,1,.264,2.236c.131,1.841.395,2.893-2.1,4.47,0,0,.264,3.025-.657,3.815a18.9,18.9,0,0,1-1.972,1.446s-2.894,3.55-4.6,3.288-4.18,1.841-4.18,1.841-9.292-3.852-8.311-4.942l3.208-3.57s-6.367-4.639-6.236-6.086.658-1.578.658-1.578-.264-2.762,1.972-3.025c0,0,1.71-3.419,3.419-3.55s13.283,4.077,13.283,4.077l-4.339-3.682s-4.34-.658-4.208-2.1S1124.211,614.99,1124.211,614.99Z",
    transform: "translate(-1111.189 -614.99)",
    fill: "#ffbf9d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16541",
    "data-name": "Group 16541",
    transform: "translate(37.513 62.04)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16540",
    "data-name": "Group 16540"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16539",
    "data-name": "Group 16539"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63249",
    "data-name": "Path 63249",
    d: "M1123.347,630.085c-.108.167-2.636-1.3-5.87-2.851s-5.948-2.638-5.882-2.826c.055-.172,2.906.619,6.181,2.207S1123.448,629.936,1123.347,630.085Z",
    transform: "translate(-1111.594 -624.385)",
    fill: "#ff9a6c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16544",
    "data-name": "Group 16544",
    transform: "translate(40.433 58.155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16543",
    "data-name": "Group 16543"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16542",
    "data-name": "Group 16542"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63250",
    "data-name": "Path 63250",
    d: "M1128.809,626.8c-.067.178-3.446-.918-7.547-2.447s-7.374-2.914-7.308-3.092,3.445.918,7.548,2.449S1128.875,626.626,1128.809,626.8Z",
    transform: "translate(-1113.954 -621.245)",
    fill: "#ff9a6c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16547",
    "data-name": "Group 16547",
    transform: "translate(2.007 24.092)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16546",
    "data-name": "Group 16546"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16545",
    "data-name": "Group 16545"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63251",
    "data-name": "Path 63251",
    d: "M1170.36,594.909a3.309,3.309,0,0,1-.688.038l-1.992,0-7.476-.087-26-.5.239-.1c-4.04,4.188-8.459,8.773-13.071,13.555l-27.1,27.894-8.269,8.4q-1.427,1.42-2.273,2.258a6.735,6.735,0,0,1-.826.756,6.808,6.808,0,0,1,.728-.851q.809-.874,2.18-2.35l8.112-8.55,26.955-28.034,13.1-13.525.1-.1.141,0,26,.747,7.473.271,1.988.1A3.3,3.3,0,0,1,1170.36,594.909Z",
    transform: "translate(-1082.898 -593.716)",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16564",
    "data-name": "Group 16564",
    transform: "translate(1041.812 693.457)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16551",
    "data-name": "Group 16551",
    transform: "translate(0 0.193)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16550",
    "data-name": "Group 16550"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17508",
    "data-name": "Rectangle 17508",
    width: 91.607,
    height: 16.181,
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16554",
    "data-name": "Group 16554",
    transform: "translate(10.149 27.492)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16553",
    "data-name": "Group 16553"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16552",
    "data-name": "Group 16552"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63252",
    "data-name": "Path 63252",
    d: "M1047.543,711.57c-.189,0-.344-7.981-.344-17.824s.155-17.825.344-17.825.344,7.98.344,17.825S1047.732,711.57,1047.543,711.57Z",
    transform: "translate(-1047.199 -675.921)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16557",
    "data-name": "Group 16557",
    transform: "translate(30.383 27.653)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16556",
    "data-name": "Group 16556"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16555",
    "data-name": "Group 16555"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63253",
    "data-name": "Path 63253",
    d: "M1063.9,711.378c-.19,0-.344-7.909-.344-17.663s.153-17.664.344-17.664.343,7.906.343,17.664S1064.085,711.378,1063.9,711.378Z",
    transform: "translate(-1063.552 -676.051)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16560",
    "data-name": "Group 16560",
    transform: "translate(73.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16559",
    "data-name": "Group 16559"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16558",
    "data-name": "Group 16558"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63254",
    "data-name": "Path 63254",
    d: "M1098.983,669.43c-.182.019-.666-3.493-.72-7.856s.327-7.886.509-7.872.116,3.53.179,7.863S1099.179,669.412,1098.983,669.43Z",
    transform: "translate(-1098.256 -653.702)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16563",
    "data-name": "Group 16563",
    transform: "translate(88.696 0.448)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16562",
    "data-name": "Group 16562"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16561",
    "data-name": "Group 16561"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63255",
    "data-name": "Path 63255",
    d: "M1113.7,654.064a9.438,9.438,0,0,1,.6,2.621,63.2,63.2,0,0,1,.664,6.443,13.292,13.292,0,0,1-.146,3.627,4.566,4.566,0,0,1-1.514,2.619,3.133,3.133,0,0,1-1.891.77c-.49,0-.739-.119-.729-.155a3.752,3.752,0,0,0,2.3-.979,4.273,4.273,0,0,0,1.218-2.386,14.4,14.4,0,0,0,.08-3.46C1114.012,658.146,1113.5,654.094,1113.7,654.064Z",
    transform: "translate(-1110.68 -654.064)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16769",
    "data-name": "Group 16769",
    transform: "translate(1059.574 486.191)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16726",
    "data-name": "Group 16726",
    transform: "translate(0.454 4.996)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16725",
    "data-name": "Group 16725"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16724",
    "data-name": "Group 16724"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16723",
    "data-name": "Group 16723"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16722",
    "data-name": "Group 16722"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16571",
    "data-name": "Group 16571",
    transform: "translate(4.654 10.509)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16570",
    "data-name": "Group 16570"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16569",
    "data-name": "Group 16569"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16568",
    "data-name": "Group 16568"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16567",
    "data-name": "Group 16567"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16566",
    "data-name": "Group 16566"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16565",
    "data-name": "Group 16565"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63256",
    "data-name": "Path 63256",
    d: "M1062.335,538.419a99.333,99.333,0,0,1-4.381-16.568,34.709,34.709,0,0,1,1.3-16.934c.3-.814,2.855-6.277,3.718-6.2.617.058-.95,5.151-.637,5.685,3,5.1,3.828,11.246,3.374,17.143a77.427,77.427,0,0,1-3.369,16.868",
    transform: "translate(-1057.48 -498.721)",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16576",
    "data-name": "Group 16576",
    transform: "translate(8.84 1.673)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16575",
    "data-name": "Group 16575"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16574",
    "data-name": "Group 16574"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16573",
    "data-name": "Group 16573"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16572",
    "data-name": "Group 16572"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63257",
    "data-name": "Path 63257",
    d: "M1093.737,571.7c.027-4.04.062-7.23.093-7.23,0,0,13.858-1.453,14.714-15.193.412-6.637.151-20.375-.229-32.8a25.65,25.65,0,0,0-24.363-24.827l-1.327-.066c-14.347.123-22.257,12.375-21.739,26.711l.185,42.636,28.491,20.375Z",
    transform: "translate(-1060.864 -491.58)",
    fill: "#ffbf9d"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16585",
    "data-name": "Group 16585",
    transform: "translate(24.169 68.377)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16584",
    "data-name": "Group 16584"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16583",
    "data-name": "Group 16583"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16582",
    "data-name": "Group 16582"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16581",
    "data-name": "Group 16581"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16580",
    "data-name": "Group 16580"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16579",
    "data-name": "Group 16579"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16578",
    "data-name": "Group 16578"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16577",
    "data-name": "Group 16577"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63258",
    "data-name": "Path 63258",
    d: "M1090.89,551.675a33.263,33.263,0,0,1-17.638-6.185s3.792,10.418,17.574,9.865Z",
    transform: "translate(-1073.252 -545.49)",
    fill: "#ff9a6c"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16600",
    "data-name": "Group 16600",
    transform: "translate(47.748 36.411)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16599",
    "data-name": "Group 16599"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16598",
    "data-name": "Group 16598"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16597",
    "data-name": "Group 16597"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16596",
    "data-name": "Group 16596"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16595",
    "data-name": "Group 16595"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16594",
    "data-name": "Group 16594"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16593",
    "data-name": "Group 16593"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16592",
    "data-name": "Group 16592"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16591",
    "data-name": "Group 16591"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16590",
    "data-name": "Group 16590"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16589",
    "data-name": "Group 16589"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16588",
    "data-name": "Group 16588"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16587",
    "data-name": "Group 16587"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16586",
    "data-name": "Group 16586"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63259",
    "data-name": "Path 63259",
    d: "M1096.236,521.528a1.965,1.965,0,0,1-1.992,1.886,1.88,1.88,0,0,1-1.935-1.871,1.967,1.967,0,0,1,1.99-1.888A1.882,1.882,0,0,1,1096.236,521.528Z",
    transform: "translate(-1092.309 -519.655)",
    fill: "#263238"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16616",
    "data-name": "Group 16616",
    transform: "translate(45.313 29.863)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16615",
    "data-name": "Group 16615"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16614",
    "data-name": "Group 16614"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16613",
    "data-name": "Group 16613"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16612",
    "data-name": "Group 16612"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16611",
    "data-name": "Group 16611"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16610",
    "data-name": "Group 16610"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16609",
    "data-name": "Group 16609"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16608",
    "data-name": "Group 16608"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16607",
    "data-name": "Group 16607"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16606",
    "data-name": "Group 16606"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16605",
    "data-name": "Group 16605"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16604",
    "data-name": "Group 16604"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16603",
    "data-name": "Group 16603"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16602",
    "data-name": "Group 16602"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16601",
    "data-name": "Group 16601"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63260",
    "data-name": "Path 63260",
    d: "M1098.1,516.625c-.256.244-1.687-.932-3.8-1.031-2.109-.13-3.714.88-3.931.609-.107-.12.164-.57.864-1.028a5.406,5.406,0,0,1,3.163-.8,5.177,5.177,0,0,1,3.01,1.141C1098.025,516.042,1098.221,516.516,1098.1,516.625Z",
    transform: "translate(-1090.341 -514.363)",
    fill: "#263238"
  }))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16631",
    "data-name": "Group 16631",
    transform: "translate(28.797 36.539)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16630",
    "data-name": "Group 16630"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16629",
    "data-name": "Group 16629"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16628",
    "data-name": "Group 16628"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16627",
    "data-name": "Group 16627"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16626",
    "data-name": "Group 16626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16625",
    "data-name": "Group 16625"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16624",
    "data-name": "Group 16624"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16623",
    "data-name": "Group 16623"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16622",
    "data-name": "Group 16622"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16621",
    "data-name": "Group 16621"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16620",
    "data-name": "Group 16620"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16619",
    "data-name": "Group 16619"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16618",
    "data-name": "Group 16618"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16617",
    "data-name": "Group 16617"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63261",
    "data-name": "Path 63261",
    d: "M1080.92,521.632a1.965,1.965,0,0,1-1.992,1.886,1.879,1.879,0,0,1-1.935-1.871,1.968,1.968,0,0,1,1.99-1.888A1.883,1.883,0,0,1,1080.92,521.632Z",
    transform: "translate(-1076.993 -519.759)",
    fill: "#263238"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16647",
    "data-name": "Group 16647",
    transform: "translate(24.574 29.686)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16646",
    "data-name": "Group 16646"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16645",
    "data-name": "Group 16645"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16644",
    "data-name": "Group 16644"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16643",
    "data-name": "Group 16643"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16642",
    "data-name": "Group 16642"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16641",
    "data-name": "Group 16641"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16640",
    "data-name": "Group 16640"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16639",
    "data-name": "Group 16639"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16638",
    "data-name": "Group 16638"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16637",
    "data-name": "Group 16637"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16636",
    "data-name": "Group 16636"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16635",
    "data-name": "Group 16635"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16634",
    "data-name": "Group 16634"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16633",
    "data-name": "Group 16633"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16632",
    "data-name": "Group 16632"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63262",
    "data-name": "Path 63262",
    d: "M1081.336,516.481c-.257.245-1.692-.931-3.8-1.029-2.109-.13-3.713.88-3.93.609-.106-.12.161-.569.864-1.027a5.4,5.4,0,0,1,3.163-.805,5.188,5.188,0,0,1,3.01,1.14C1081.261,515.9,1081.459,516.373,1081.336,516.481Z",
    transform: "translate(-1073.58 -514.22)",
    fill: "#263238"
  }))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16662",
    "data-name": "Group 16662",
    transform: "translate(38.983 30.907)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16661",
    "data-name": "Group 16661"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16660",
    "data-name": "Group 16660"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16659",
    "data-name": "Group 16659"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16658",
    "data-name": "Group 16658"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16657",
    "data-name": "Group 16657"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16656",
    "data-name": "Group 16656"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16655",
    "data-name": "Group 16655"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16654",
    "data-name": "Group 16654"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16653",
    "data-name": "Group 16653"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16652",
    "data-name": "Group 16652"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16651",
    "data-name": "Group 16651"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16650",
    "data-name": "Group 16650"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16649",
    "data-name": "Group 16649"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16648",
    "data-name": "Group 16648"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63263",
    "data-name": "Path 63263",
    d: "M1085.341,532.86a14.007,14.007,0,0,1,3.462-.448c.542-.029,1.058-.11,1.168-.474a2.756,2.756,0,0,0-.281-1.617q-.662-2-1.391-4.188c-1.924-5.959-3.287-10.849-3.047-10.924s2,4.694,3.92,10.653q.692,2.2,1.323,4.209a3.125,3.125,0,0,1,.173,2.132,1.353,1.353,0,0,1-.926.745,3.681,3.681,0,0,1-.923.082A13.735,13.735,0,0,1,1085.341,532.86Z",
    transform: "translate(-1085.225 -515.207)",
    fill: "#263238"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16677",
    "data-name": "Group 16677",
    transform: "translate(32.403 49.712)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16676",
    "data-name": "Group 16676"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16675",
    "data-name": "Group 16675"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16674",
    "data-name": "Group 16674"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16673",
    "data-name": "Group 16673"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16672",
    "data-name": "Group 16672"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16671",
    "data-name": "Group 16671"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16670",
    "data-name": "Group 16670"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16669",
    "data-name": "Group 16669"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16668",
    "data-name": "Group 16668"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16667",
    "data-name": "Group 16667"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16666",
    "data-name": "Group 16666"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16665",
    "data-name": "Group 16665"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16664",
    "data-name": "Group 16664"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16663",
    "data-name": "Group 16663"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63264",
    "data-name": "Path 63264",
    d: "M1080.312,530.405c.345,0,.235,2.29,2.117,4.016s4.336,1.595,4.337,1.917c.025.146-.567.418-1.6.395a5.724,5.724,0,0,1-3.628-1.47,4.985,4.985,0,0,1-1.627-3.361C1079.871,530.94,1080.156,530.384,1080.312,530.405Z",
    transform: "translate(-1079.907 -530.405)",
    fill: "#263238"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16688",
    "data-name": "Group 16688",
    transform: "translate(22.951 21.57)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16687",
    "data-name": "Group 16687"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16686",
    "data-name": "Group 16686"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16685",
    "data-name": "Group 16685"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16684",
    "data-name": "Group 16684"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16683",
    "data-name": "Group 16683"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16682",
    "data-name": "Group 16682"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16681",
    "data-name": "Group 16681"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16680",
    "data-name": "Group 16680"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16679",
    "data-name": "Group 16679"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16678",
    "data-name": "Group 16678"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63265",
    "data-name": "Path 63265",
    d: "M1081.957,509.458c-.236.565-2.332.187-4.827.363-2.5.125-4.532.751-4.835.219-.135-.254.241-.777,1.076-1.293a8.416,8.416,0,0,1,7.362-.442C1081.625,508.715,1082.061,509.19,1081.957,509.458Z",
    transform: "translate(-1072.268 -507.661)",
    fill: "#263238"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16699",
    "data-name": "Group 16699",
    transform: "translate(45.37 22.679)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16698",
    "data-name": "Group 16698"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16697",
    "data-name": "Group 16697"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16696",
    "data-name": "Group 16696"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16695",
    "data-name": "Group 16695"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16694",
    "data-name": "Group 16694"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16693",
    "data-name": "Group 16693"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16692",
    "data-name": "Group 16692"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16691",
    "data-name": "Group 16691"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16690",
    "data-name": "Group 16690"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16689",
    "data-name": "Group 16689"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63266",
    "data-name": "Path 63266",
    d: "M1097.562,510.936c-.4.46-1.826-.11-3.576-.22-1.745-.172-3.248.161-3.563-.359-.137-.25.12-.719.789-1.141a5.185,5.185,0,0,1,5.754.465C1097.56,510.206,1097.738,510.71,1097.562,510.936Z",
    transform: "translate(-1090.387 -508.557)",
    fill: "#263238"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16706",
    "data-name": "Group 16706",
    transform: "translate(0 38.025)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16705",
    "data-name": "Group 16705"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16704",
    "data-name": "Group 16704"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16703",
    "data-name": "Group 16703"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16702",
    "data-name": "Group 16702"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16701",
    "data-name": "Group 16701"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16700",
    "data-name": "Group 16700"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63267",
    "data-name": "Path 63267",
    d: "M1063.2,521.557c-.229-.114-9.307-3.267-9.477,6.148s9.318,7.642,9.341,7.372S1063.2,521.557,1063.2,521.557Z",
    transform: "translate(-1053.719 -520.959)",
    fill: "#ffbf9d"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16714",
    "data-name": "Group 16714",
    transform: "translate(2.389 41.044)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16713",
    "data-name": "Group 16713"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16712",
    "data-name": "Group 16712"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16711",
    "data-name": "Group 16711"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16710",
    "data-name": "Group 16710"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16709",
    "data-name": "Group 16709"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16708",
    "data-name": "Group 16708"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16707",
    "data-name": "Group 16707"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63268",
    "data-name": "Path 63268",
    d: "M1059.791,530.88c-.041-.031-.166.113-.445.234a1.637,1.637,0,0,1-1.226,0c-.989-.382-1.8-1.977-1.813-3.675a5.413,5.413,0,0,1,.5-2.34,1.9,1.9,0,0,1,1.256-1.237.836.836,0,0,1,.96.468c.121.265.058.452.108.469.026.025.205-.155.136-.544a1.045,1.045,0,0,0-.36-.6,1.238,1.238,0,0,0-.9-.256,2.3,2.3,0,0,0-1.74,1.429,5.582,5.582,0,0,0-.616,2.614c.027,1.9.966,3.691,2.32,4.108a1.756,1.756,0,0,0,1.5-.221C1059.77,531.107,1059.823,530.9,1059.791,530.88Z",
    transform: "translate(-1055.65 -523.399)",
    fill: "#ff9a6c"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16721",
    "data-name": "Group 16721",
    transform: "translate(5.027)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16720",
    "data-name": "Group 16720"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16719",
    "data-name": "Group 16719"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16718",
    "data-name": "Group 16718"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16717",
    "data-name": "Group 16717"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16716",
    "data-name": "Group 16716"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16715",
    "data-name": "Group 16715"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63269",
    "data-name": "Path 63269",
    d: "M1103.1,501.139c1.532-.827-3-5.8-6.726-7.537-5.637-2.619-14.265-4.279-19.5-2.846-6.3,1.724-11.548,4.8-14.754,10.493a37.028,37.028,0,0,0-4.329,18.872,11.25,11.25,0,0,0,1.275,5.765c1.3,2.094,3.807,3.427,3.671,6.3a3.941,3.941,0,0,0,.952,2.883c1.706,1.849,3.829.146,4.814-1.571,2.1-3.67,2.373-8.071,2.593-12.294a27.515,27.515,0,0,0-.514-8.96c-.447-1.574-1.173-3.064-1.532-4.66a5.66,5.66,0,0,1,.71-4.694,5.835,5.835,0,0,1,.772-.767,9.821,9.821,0,0,1,9.759-1.766c5.285,1.924,14.315,4.808,16.7,3.03,3.426-2.558,4.255-4.239,4.255-4.239Z",
    transform: "translate(-1057.782 -490.228)",
    fill: "#263238"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16730",
    "data-name": "Group 16730"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16729",
    "data-name": "Group 16729"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16728",
    "data-name": "Group 16728"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16727",
    "data-name": "Group 16727"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63270",
    "data-name": "Path 63270",
    d: "M1078.836,486.29c-.631.059-15.968,2.817-20.266,13.96s-3.338,14.665-3.338,14.665a7.415,7.415,0,0,0-1.646,1.293c-.663.715.1,4.32,2.1,4.005,15.121-5.908,32.706-5.793,52.236-4.321l14.984.476c4.171.673,5.693-.375,3.971-1.506-1.32-.867-13.008-6.171-13.008-6.171l-2.263-1.808-5.806-8.848s.817-1.159-.651-2.22S1091.3,485.113,1078.836,486.29Z",
    transform: "translate(-1053.352 -486.191)",
    fill: "#ff725e"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16735",
    "data-name": "Group 16735",
    transform: "translate(1.802 20.105)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16734",
    "data-name": "Group 16734"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16733",
    "data-name": "Group 16733"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16732",
    "data-name": "Group 16732"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16731",
    "data-name": "Group 16731"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63271",
    "data-name": "Path 63271",
    d: "M1111.261,503.028s-.2,0-.584-.022l-1.671-.11c-1.446-.126-3.549-.2-6.144-.26a115.869,115.869,0,0,0-20.2,1.592,178.046,178.046,0,0,0-19.774,4.534c-2.5.7-4.515,1.309-5.908,1.72l-1.606.471c-.367.105-.565.148-.565.148s.187-.076.551-.2l1.591-.517c1.386-.439,3.391-1.074,5.888-1.8a166.486,166.486,0,0,1,19.782-4.61,110.891,110.891,0,0,1,20.244-1.522A84.1,84.1,0,0,1,1111.261,503.028Z",
    transform: "translate(-1054.809 -502.439)",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16740",
    "data-name": "Group 16740",
    transform: "translate(11.321 3.017)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16739",
    "data-name": "Group 16739"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16738",
    "data-name": "Group 16738"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16737",
    "data-name": "Group 16737"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16736",
    "data-name": "Group 16736"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63272",
    "data-name": "Path 63272",
    d: "M1062.5,491.764s16.483-1.92,23.653,1.928l-.831-.466,6.788,3.352c1.147.567,2.494,1.138,3.651.594a32.5,32.5,0,0,0-10.293-6.1C1078.727,488.448,1067.9,486.971,1062.5,491.764Z",
    transform: "translate(-1062.502 -488.629)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16745",
    "data-name": "Group 16745",
    transform: "translate(11.08 2.932)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16744",
    "data-name": "Group 16744"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16743",
    "data-name": "Group 16743"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16742",
    "data-name": "Group 16742"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16741",
    "data-name": "Group 16741"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63273",
    "data-name": "Path 63273",
    d: "M1062.307,491.856a11.706,11.706,0,0,1,1.508-.895,20.345,20.345,0,0,1,4.478-1.683,24.272,24.272,0,0,1,7.057-.693,20.383,20.383,0,0,1,8.417,2.038,36.856,36.856,0,0,1,3.868,2.311c1.2.82,2.392,1.548,3.466,2.357a21.872,21.872,0,0,0,3.087,2.154,7.072,7.072,0,0,0,3.133.778c4.019.234,6.526-.489,6.355-.751a.646.646,0,0,1-.335.3,5.1,5.1,0,0,1-1.253.36,21.778,21.778,0,0,1-4.776.265,7.2,7.2,0,0,1-3.219-.77,21.858,21.858,0,0,1-3.13-2.154c-1.059-.792-2.263-1.522-3.462-2.336a37.047,37.047,0,0,0-3.844-2.293,20.385,20.385,0,0,0-8.316-2.032,24.617,24.617,0,0,0-7,.635,21.51,21.51,0,0,0-4.475,1.6c-.507.245-.892.452-1.149.6S1062.307,491.856,1062.307,491.856Z",
    transform: "translate(-1062.307 -488.56)",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16750",
    "data-name": "Group 16750",
    transform: "translate(2.812 13.453)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16749",
    "data-name": "Group 16749"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16748",
    "data-name": "Group 16748"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16747",
    "data-name": "Group 16747"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16746",
    "data-name": "Group 16746"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63274",
    "data-name": "Path 63274",
    d: "M1056.4,502.329c2.934.11,5.193-.552,8.134-1.059,3.133-.541,6.231-.94,9.336-1.631,2.356-.523,5.134-.961,6.726-2.576a3.4,3.4,0,0,1-1.177,3.128c-.931.815-3.867,1.705-5.073,1.977-6.88,1.549-11.643,2.584-18.718,2.759a20.086,20.086,0,0,1,.772-2.6",
    transform: "translate(-1055.625 -497.063)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16754",
    "data-name": "Group 16754",
    transform: "translate(2.539 11.133)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16753",
    "data-name": "Group 16753"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16752",
    "data-name": "Group 16752"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16751",
    "data-name": "Group 16751"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63275",
    "data-name": "Path 63275",
    d: "M1058.611,496.9c-1.894.724-3.059,1.216-3.182,2.8-.1,1.315.092,2.939,1.38,3.227a3.212,3.212,0,0,0,1.2-.035l20.432-3.179a3.016,3.016,0,0,0,1.9-.777,2.051,2.051,0,0,0-.578-2.816,5.631,5.631,0,0,0-3.07-.827,67.44,67.44,0,0,0-18.08,1.61",
    transform: "translate(-1055.405 -495.188)",
    fill: "#ff725e"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16759",
    "data-name": "Group 16759",
    transform: "translate(4.318 10.393)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16758",
    "data-name": "Group 16758"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16757",
    "data-name": "Group 16757"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16756",
    "data-name": "Group 16756"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16755",
    "data-name": "Group 16755"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63276",
    "data-name": "Path 63276",
    d: "M1079.672,499.356a1.935,1.935,0,0,0,.584-.859,2.541,2.541,0,0,0-.718-2.592,6.307,6.307,0,0,0-4.032-1.083c-1.628.009-3.421.043-5.3.142a53.931,53.931,0,0,0-9.525,1.256c-1.2.275-2.156.56-2.815.758l-.757.238a1.126,1.126,0,0,1-.27.067,1.141,1.141,0,0,1,.252-.115l.744-.282c.652-.228,1.6-.541,2.8-.839a49.329,49.329,0,0,1,9.553-1.334c1.883-.1,3.677-.127,5.312-.122a6.384,6.384,0,0,1,4.151,1.183,2.626,2.626,0,0,1,.69,2.755,1.71,1.71,0,0,1-.444.671A.9.9,0,0,1,1079.672,499.356Z",
    transform: "translate(-1056.842 -494.591)",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16763",
    "data-name": "Group 16763",
    transform: "translate(41.543 13.787)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16762",
    "data-name": "Group 16762"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16761",
    "data-name": "Group 16761"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16760",
    "data-name": "Group 16760"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63277",
    "data-name": "Path 63277",
    d: "M1099.655,498.168l-12.728-.835.916,3.638,13.865.326Z",
    transform: "translate(-1086.927 -497.333)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16768",
    "data-name": "Group 16768",
    transform: "translate(34.496 22.821)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16767",
    "data-name": "Group 16767"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16766",
    "data-name": "Group 16766"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16765",
    "data-name": "Group 16765"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16764",
    "data-name": "Group 16764"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63278",
    "data-name": "Path 63278",
    d: "M1081.232,506.88c-.006-.069,5.71-.626,12.766-1.245s12.783-1.063,12.789-.994-5.709.627-12.767,1.245S1081.238,506.949,1081.232,506.88Z",
    transform: "translate(-1081.232 -504.634)",
    fill: "#263238"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignUp);
export default __webpack_public_path__ + "static/media/signUp.ac0a349cffbce6afe0d445f546b9b5b9.svg";
export { ForwardRef as ReactComponent };